import { render, staticRenderFns } from "./ficha-matricula.vue?vue&type=template&id=cdd23760&scoped=true&"
import script from "./ficha-matricula.vue?vue&type=script&lang=js&"
export * from "./ficha-matricula.vue?vue&type=script&lang=js&"
import style0 from "./ficha-matricula.vue?vue&type=style&index=0&id=cdd23760&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd23760",
  null
  
)

export default component.exports